const bell = {
  state: {
    bells: [],
    titleInterval: null,
  },
  mutations: {
    ADD_BELLS(state, notifications) {
      state.bells = notifications;
    },
    ADD_INTERVAL(state, interval){
      state.titleInterval = interval;
    },
    REMOVE_INTERVAL(state){
      clearInterval(state.titleInterval);
      state.titleInterval = null;
    },
  },
  actions: {
    addBells({ commit, state }, notifications) {
      commit("ADD_BELLS", notifications);
    },
    addBellTitleInterval({ commit }, interval){
      commit("ADD_INTERVAL", interval);
    },
    removeBellTitleInterval({commit}){
      commit("REMOVE_INTERVAL");
    },
  }
};

export default bell;
